import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/facility/tech"

const serviceName = "TechnicalInfo-Service: ";

export default class TechnicalInfoService {

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF);
  }

  static putToAPI(facilityId, info, successF, errorF) {
    return WrapperService.put(API_URL + "/" + facilityId, info, serviceName, successF, errorF);
  }
}
